import { Component, OnInit } from '@angular/core';
import { TravelReimbursementApproverViewComponent } from '../travel-reimbursement-approver-view/travel-reimbursement-approver-view.component';
import { reimbursementApproverUrl } from 'src/app/modules/shared/common/api';
import { Travel } from 'src/app/models/travel';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { TravelReimbursementService } from '../../services/travel-reimbursement.service';
import { FunctionsService } from 'src/app/modules/shared/services/functions.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { User } from 'src/app/models/user';
import { ActivatedRoute } from '@angular/router';
import { TravelService } from 'src/app/modules/travel/services/travel/travel.service';

@Component({
  selector: 'app-travel-reimbursement-approver',
  templateUrl: './travel-reimbursement-approver.component.html',
  styleUrls: ['./travel-reimbursement-approver.component.scss']
})
export class TravelReimbursementApproverComponent implements OnInit {

  keyWords = {};
  newKeyWords = {};
  menuList = [
    {
      label:"Date Submitted",
      type: 'date',
      name:"date_submitted",
      value: [],
    },
    {
      label:"Purpose",
      type:"input",
      name:"purpose",
    },
    {
      label:"Location",
      type:"input",
      name:"location",
    },
    {
      label:"Status",
      type:"select",
      name:"status",
      value: ["For Approval" ,"For Verification" ,"Closed" ,"Rejected"].sort()
    }
  ];
  

  isNoResult: boolean = false;
  loading:boolean = false;
  isRole:boolean = false;
  isKeyWord:boolean = false;
  keyTable = '';
  params:any;
  totalRec : number;
  page: number = 1;
  perPage: number;

  travel: any;
  dialogConfig:any;
  departmentList:any;
  formGroup: FormGroup;
  user = new User();

  pipe = new DatePipe('en-US');

  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public reimburseService: TravelReimbursementService,
    public functionService: FunctionsService,
    public travelService: TravelService,
    private route: ActivatedRoute
  ) { 
    this.isRole = this.user.getRole();
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      reimbursement_no:['',null],
      travel_request:['',null],
      cash_advance_no:['',null],
      complete_name: ['',null],
      date_filed: ['',null],
      date_submitted: ['',null],
      travel_reason:['',null],
      location: ['',null],
      status: ['',null],
      dashboard: ['',null],
      purpose: ['',null],
      department_filter: ['',null],
      travel_type:['',null],
    });

    this.keyWords = [];

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';
    this.dialogConfig.backdropClass = 'mat-dialog-backdrop';

    if (this.isRole) {
      this.travelService.getDepartment().subscribe(res=>{
        this.departmentList = res;
        this.menuList.unshift({
          label:"Department",
          type:"select",
          name:"department_filter",
          value: this.departmentList,
        });
      });

      this.menuList.unshift({
        label:"Requestor",
        type:"input",
        name:"complete_name"
      });
    }

    //check status param router if set
    this.route.queryParams.subscribe( params =>{
      if (params['email']) {
        this.params = params;
        this.formGroup.controls['reimbursement_no'].setValue(params['email']);
        this.getFilter();
        return;
      } else if (params['status'] || params['dashboard'] || params['travel_type']) {
        this.formGroup.controls['status'].setValue(params.status);
        this.formGroup.controls['dashboard'].setValue(params.dashboard);
        if (this.formGroup.controls['status'].value && this.formGroup.controls['dashboard'].value) {
          this.newKeyWords = {status: this.formGroup.controls['status'].value, dashboard: this.formGroup.controls['dashboard'].value}
        }
        this.getFilter();
      } else {
        this.keyWords = {};
        this.getList();
      }
    });

  }

  getFilter() {
    this.page = 1;
    this.isKeyWord = true;
    if (this.isKeyWord) {
      this.keyTable = 'table-chiplist';
    }
    if(this.formGroup.controls['date_submitted'].value !== '' && this.formGroup.controls['date_submitted'].value !== null){
      this.formGroup.controls['date_submitted'].setValue(this.pipe.transform(this.formGroup.controls['date_submitted'].value, 'yyyy-MM-dd'));
    }
    this.getList();
    if (Object.keys(this.newKeyWords).length > 0) {
      delete this.newKeyWords['dashboard'];
      this.keyWords = this.newKeyWords;
    } else {
      this.keyWords = [];
      this.keyWords = this.functionService.filter(this.formGroup,this.keyWords);
    }
  }

  getList() {
    let param = [];
    let queryString = '';

    if (this.page) {
      param.push('page='+this.page);
    }  

    if(this.formGroup.controls['reimbursement_no'].value !== null){
      param.push('reimbursement_no='+this.formGroup.controls['reimbursement_no'].value);
    }

    if(this.formGroup.controls['travel_request'].value !== null){
      param.push('travel_request='+encodeURIComponent(this.formGroup.controls['travel_request'].value));
    }

    if(this.formGroup.controls['complete_name'].value !== null){
      param.push('complete_name='+this.formGroup.controls['complete_name'].value);
    }
    
    if(this.formGroup.controls['date_submitted'].value !== null){
      param.push('date_submitted='+this.formGroup.controls['date_submitted'].value);
    }
    
    if(this.formGroup.controls['department_filter'].value !== null){
      param.push('department_filter='+this.formGroup.controls['department_filter'].value);
    }

    if(this.formGroup.controls['status'].value !== null){
      param.push('status='+this.formGroup.controls['status'].value);
    }

    if(this.formGroup.controls['dashboard'].value !== null){
      param.push('dashboard='+this.formGroup.controls['dashboard'].value);
    }

    if(this.formGroup.controls['purpose'].value !== null){
      param.push('purpose='+this.formGroup.controls['purpose'].value);
    }

    if(this.formGroup.controls['location'].value !== null){
      param.push('location='+this.formGroup.controls['location'].value);
    }

    if(this.formGroup.controls['travel_type'].value !== null){
      param.push('travel_type='+this.formGroup.controls['travel_type'].value);
    }
  
    if (param.length) {
      queryString = '?' + param.join('&');
    }

    this.loading = true;
    this.isNoResult = false;
    this.reimburseService.url = reimbursementApproverUrl +''+ queryString;
    this.reimburseService.getFilter().subscribe(res=>{
      if (res.data) {
        this.travel = new Travel(res.data);
      }
      if (this.params) {
        if (res.data[0]) {
          this.openDetail(res.data[0]);
          this.params = '';
        }
      }
      this.totalRec = res.total;
      this.perPage = res.per_page;
      this.loading = false;
      if (res.total == 0) {
        this.isNoResult = true;
      }
    });
  }

  onClearForm() {
    this.formGroup.reset();
    this.keyWords = [];
    this.getList();
    this.isKeyWord  = false;
    this.keyTable = '';
  }

  openDetail(res) {
    this.dialogConfig.data = {res};
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.width = '100vw';
    let dialogRef = this.dialog.open(TravelReimbursementApproverViewComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getList();
      }
    });
  }

  pageChange(newPage: number) {
    this.page = newPage;
    this.getList();
		return false;
  }
  
  removeKeywords(key){
    this.formGroup.controls[key].setValue('');
    this.functionService.removeFilter(this.keyWords,key);
    this.getList();
    this.keyTable = '';
  }

}
